import { createEvent} from 'ics';

export default class AddToCalendar{

	constructor(element) {
		this.item = element;

		this.start = parseInt(this.item.dataset.startDate) * 1000;
		this.end = parseInt(this.item.dataset.endDate) * 1000;
		this.slug = this.item.dataset.slug;
		this.title = this.item.dataset.title;
		// this.description = this.item.dataset.description;
		this.location = this.item.dataset.location;
		this.bindEvents();
		
		this.item.isInit = true;
	}

	bindEvents(){
		this.item.addEventListener('click', (e) => {
			e.preventDefault();
			this.handleDownload();
		});
	}

	async handleDownload() {
		let event = {
			productId:"opcommerce/id",
			uid: this.slug+'@opcommerce',
			startOutputType:"local",
			start: this.start,
			end:this.end,
			title: this.title,
			// description:this.description,
			location:this.location,
		}
		const filename = this.slug+'.ics'
		const file = await new Promise((resolve, reject) => {
			createEvent(event, (error, value) => {
				if (error) {
					reject(error)
				}

				resolve(new File([value], filename, { type: 'text/calendar' }))
			})
		})
		const url = URL.createObjectURL(file);

		// trying to assign the file URL to a window could cause cross-site
		// issues so this is a workaround using HTML5
		const anchor = document.createElement('a');
		anchor.href = url;
		anchor.download = filename;

		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);

		URL.revokeObjectURL(url);
	}
}
